import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { useMessageMediaService } from '@/modules/message/service/message-fetch-context'

export function useMessageMedias() {
  const creatorId = useUnit($creatorId)
  const { list } = useMessageMediaService()

  return useQuery(['message-medias', creatorId], () => list(creatorId!), {
    enabled: !!creatorId,
  })
}
